import { render } from "./TouchControl.vue?vue&type=template&id=70130a4e&scoped=true"
import script from "./TouchControl.vue?vue&type=script&lang=js"
export * from "./TouchControl.vue?vue&type=script&lang=js"

import "./TouchControl.vue?vue&type=style&index=0&id=70130a4e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70130a4e"]])

export default __exports__